<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('re1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>到期日报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item label="客户类型">
                                <el-select v-model="searchform.type" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="新客" value="1"></el-option>
                                    <el-option label="老客" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('channel')">
                                <el-select size="small" v-model="searchform.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                    <el-option v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="App">
                                <el-select v-model="searchform.app" @change="onAppChange" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="Aktivaku" value="Aktivaku"></el-option>
                                    <el-option label="Sanders" value="Sanders"></el-option>
                                    <el-option label="papitupi" value="papitupi"></el-option>
                                    <el-option label="Igrow" value="Igrow"></el-option>
                                    <el-option label="DanaBijak" value="DanaBijak"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="子产品">
                                <el-select v-model="searchform.platform" :disabled="filteredPlatforms.length === 0" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option
                                        v-for="item in filteredPlatforms"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="结清次数等于">
                                <el-select v-model="searchform.number" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="0" value="0"></el-option>
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3+" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="到期日时间">
                                <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="date" label="到期日"></el-table-column>
                        <el-table-column prop="maturity_count" label="到期cnt"></el-table-column>
                        <el-table-column prop="2_day_early_repayment_count_rate_including_extension" label="累计提前2天还款cnt率(含展期)"></el-table-column>
                        <el-table-column prop="h2_repayment_count_rate" label="H2还款(cnt)率"></el-table-column>
                        <el-table-column prop="1_day_early_repayment_count_rate_including_extension" label="累计提前1天还款cnt率(含展期)"></el-table-column>
                        <el-table-column prop="h1_repayment_count_rate" label="H1还款(cnt)率"></el-table-column>
                        <el-table-column prop="same_day_repayment_count_rate_including_extension" label="累计还款日当天还款(cnt)率(含展期)"></el-table-column>
                        <el-table-column prop="s0_repayment_count_rate" label="S0还款(cnt)率"></el-table-column>
                        <el-table-column prop="collections_entry_count" label="入催cnt"></el-table-column>
                        <el-table-column prop="general_collections_entry_amount_rate" label="广义入催amt率(含展期)"></el-table-column>
                        <el-table-column prop="general_collections_entry_count_rate" label="广义入催cnt率(含展期)"></el-table-column>
                        <el-table-column prop="specific_collections_entry_count_rate" label="狭义入催cnt率(不含展期)"></el-table-column>
                        <el-table-column prop="current_repaid_count_including_extension" label="当前已还cnt(含展期)"></el-table-column>
                        <el-table-column prop="general_outstanding_delinquency_amount_rate" label="广义在逾amt率"></el-table-column>
                        <el-table-column prop="general_outstanding_delinquency_count_rate" label="广义在逾cnt率"></el-table-column>
                        <el-table-column prop="specific_outstanding_delinquency_count_rate" label="狭义在逾cnt率"></el-table-column>
                        <el-table-column prop="extension_count" label="展期cnt"></el-table-column>
                        <el-table-column prop="extension_rate" label="展期率"></el-table-column>
                        <el-table-column prop="1_day_delinquency_rate" label="1日在逾率"></el-table-column>
                        <el-table-column prop="2_day_delinquency_rate" label="2日在逾率"></el-table-column>
                        <el-table-column prop="3_day_delinquency_rate" label="3日在逾率"></el-table-column>
                        <el-table-column prop="8_day_delinquency_rate" label="8日在逾率"></el-table-column>
                        <el-table-column prop="15_day_delinquency_rate" label="15日在逾率"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: null,
                    app:"",
                    platform:"",
                    number:"",
                },
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:null,
                typeList: [],
                platformOptions: [
                    { label: "GraDana", value: "GraDana", app: "Aktivaku" },
                    { label: "AwanTunai", value: "AwanTunai", app: "Aktivaku" },
                    { label: "Aktivaku", value: "Aktivaku", app: "Aktivaku" },
                    { label: "PinjamModal", value: "PinjamModal", app: "Aktivaku" },


                    { label: "IKIModal", value: "IKIModal", app: "Sanders" },
                    { label: "Ethis", value: "Ethis", app: "Sanders" },
                    { label: "Sanders", value: "Sanders", app: "Sanders" },
                    { label: "Akseleran", value: "Akseleran", app: "Sanders" },

                    { label: "Duha", value: "Duha", app: "papitupi" },
                    { label: "komunal", value: "komunal", app: "papitupi" },
                    { label: "papitupi", value: "papitupi", app: "papitupi" },
                    { label: "Ammana", value: "Ammana", app: "papitupi" },

                    { label: "Qazwa", value: "Qazwa", app: "Igrow" },
                    { label: "Restock", value: "Restock", app: "Igrow" },
                    { label: "Igrow", value: "Igrow", app: "Igrow" },

                    { label: "DanaMerdeka", value: "DanaMerdeka", app: "DanaBijak" },
                    { label: "DanaSyariah", value: "DanaSyariah", app: "DanaBijak" },
                    { label: "DanaBijak", value: "DanaBijak", app: "DanaBijak" },
                ]
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList()
        },

        computed: {
            filteredPlatforms() {
                if (!this.searchform.app) return []; // 默认空
                return this.platformOptions.filter(item => item.app === this.searchform.app);
            }
        },
        methods: {
            onAppChange() {
                this.searchform.platform = null; // 切换 app 时清空子产品
            },
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },

            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getList() {
                this.loading = true
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }

                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }
                _api.get(apiurl.dueDate, {
                    type: this.type,
                    createTime: this.value1,
                    app: this.searchform.app,
                    platform: this.searchform.platform,
                    number: this.searchform.number,
                    customerType: this.searchform.type,
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>